// Need to use the React-specific entry point to import createApi
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import urls from '../urls';

// Define a service using a base URL and expected endpoints
export const couponApi = createApi({
  reducerPath: 'couponApi',
  baseQuery: fetchBaseQuery({ baseUrl: urls.SERVER }),
  endpoints: (builder) => ({
    validateCoupon: builder.mutation({
      query: (data) => {
        return {
          url: `/client/validateCoupon`,
          method: "POST",
          body: data
        }
      }
    }),
  })
})

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useValidateCouponMutation
} = couponApi;
